import { Device } from '../api/device.model';
import DeviceModel from '../api/DeviceModel';
import useCommanderStatus from '../commander-status/hooks/useCommanderStatus';

export const useGetMQTTDeviceConnection = (device: Device) => {
  const { commanderStatus, isLoading } = useCommanderStatus(device.uuid);
  const { cloudConnectivityMQTT } = new DeviceModel().cloudConnectivityStatus(
    device?.lastPing,
    commanderStatus
  );

  return {
    isLoading,
    cloudConnectivityMQTT,
  };
};
